// extracted by mini-css-extract-plugin
module.exports = {"layout":"_0a3a94f455--layout--wW_IF","content":"_0a3a94f455--content--MRe04","desktop":"_0a3a94f455--desktop--RqOp8"};